import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getCostBy = (costById: number | undefined): Promise<IGetCostBy> => {
  return axiosDefaultApi.get(`api/CostBy/GetCostByViaID/${costById}`);
};

type QueryFnType = typeof getCostBy;

type UseGetCostByOptions = {
  costById: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetCostBy = ({ costById , config }: UseGetCostByOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getCostBy_${costById}`],
    queryFn: () => getCostBy(costById),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της παράμετρου 'Κόστος ανά'`, 500);
      setIsNotificationVisible(true)
    }
  });
};